import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { isCourtDrive } from '../../../../util/globalUtils';
import AdvancedSearchHelper from '../../AdvancedSearchHelper';
import {
  limitSelectOptions,
  casefoldersSelectOptions,
  querySelectOptions,
  regionSelectOptions,
  chapterSelectOptions,
  caseTypeSelectOptions,
  industrySelectOptions,
  assetsLiabilitiesSelectOptions,
} from '../../formData';
import FieldSet from '../../../Modules/FieldSet';
import {
  SearchPDFsField,
  CasesField,
  RegionField,
  QueryField,
  CaseTitlesField,
  ChapterField,
  TypeField,
  DatePickerField,
  BusinessOnlyField,
  IndustryField,
  AssetsField,
  LiabilitiesField,
  InputField,
} from '../../fields';

import '../../AdvancedSearch.less';

const PetitionsForm = ({ filter, onSubmit, onReset }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={filter}
    render={({ handleSubmit, form }) => (
      <form onSubmit={handleSubmit} className="advanced-search-form">
        <InputField placeholder="Enter Keywords" />
        <AdvancedSearchHelper />
        <div className="advanced-search-filters">
          <FieldSet title="Advanced Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <SearchPDFsField limitSelectOptions={limitSelectOptions} disabled />
              </div>
              <div className="col-2">
                <CasesField casefoldersSelectOptions={casefoldersSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Case Information">
            <div className="form-item form-item-row">
              <div className="col-2">
                <RegionField regionSelectOptions={regionSelectOptions} />
              </div>
              <div className="col-2">
                <QueryField querySelectOptions={querySelectOptions} disabled />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <ChapterField chapterSelectOptions={chapterSelectOptions} />
              </div>
              <div className="col-2">
                <TypeField caseTypeSelectOptions={caseTypeSelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <CaseTitlesField limitSelectOptions={limitSelectOptions} disabled />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Financial Filters">
            <div className="form-item form-item-row">
              <div className="col-2">
                <BusinessOnlyField limitSelectOptions={limitSelectOptions} disabled />
              </div>
              <div className="col-2">
                <IndustryField industrySelectOptions={industrySelectOptions} />
              </div>
            </div>
            <div className="form-item form-item-row">
              <div className="col-2">
                <AssetsField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
              <div className="col-2">
                <LiabilitiesField assetsLiabilitiesSelectOptions={assetsLiabilitiesSelectOptions} />
              </div>
            </div>
          </FieldSet>
          <FieldSet title="Date Filters">
            <div className="form-item">
              <label>Cases filed</label>
              <div className="form-item-row">
                <DatePickerField fieldName="date_filed_from" placeholderText="From" />
                <DatePickerField fieldName="date_filed_to" placeholderText="Through" />
              </div>
            </div>
            {!isCourtDrive() && (
              <div className="form-item">
                <label>Open cases</label>
                <div className="form-item-row">
                  <DatePickerField fieldName="open_cases_from" placeholderText="From" />
                  <DatePickerField fieldName="open_cases_to" placeholderText="Through" />
                </div>
              </div>
            )}
          </FieldSet>
        </div>
        <div className="action-btn-container">
          <button type="submit" className="btn btn-success btn-search">
            Search
          </button>
          <button
            type="button"
            className="btn btn-link"
            onClick={() => {
              form.reset();
              onReset();
            }}
          >
            Clear
          </button>
        </div>
      </form>
    )}
  />
);

PetitionsForm.propTypes = {
  filter: PropTypes.any.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
};

export default PetitionsForm;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/bankruptcy/PetitionsForm.jsx